import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import clsx from 'clsx';
import { Tooltip } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';
import css from './style.module.less';
const SettingsControl = ({ label, disabled = false, tooltip, children, }) => (_jsxs(_Fragment, { children: [_jsxs("div", { className: clsx(css.label, disabled && css.labelDisabled), children: [tooltip !== undefined && (_jsx(Tooltip, { title: tooltip, children: _jsx(InfoCircleFilled, {}) })), label, ":"] }), _jsx("div", { className: clsx(css.control, disabled && css.controlDisabled), children: children })] }));
export default SettingsControl;
